<template>
  <div class="modern-form">
    <!-- Skip form-container styling since this form is already contained -->
    <div>
    <v-form
      ref="form"
      @submit.prevent="submitForm"
      v-model="isFormValid"
      lazy-validation
      class="">
      
      <!-- Name Fields -->
      <div class="form-row three-column">
        <div class="form-group form-group-flex-2">
          <v-text-field
            v-model="form.firstName"
            label="First Name"
            :rules="[rules.required, rules.alpha_char, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required />
        </div>
        <div class="form-group form-group-flex-1">
          <v-text-field
            v-model="form.middleName"
            label="Middle Initial"
            :rules="[rules.alpha_char, rules.max25]"
            class="line-input custom-filled"
            dense
            hide-details="auto" />
        </div>
        <div class="form-group form-group-flex-2">
          <v-text-field
            v-model="form.lastName"
            label="Last Name"
            :rules="[rules.required, rules.alpha_char, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required />
        </div>
      </div>

      <!-- Preferred Name & Birth Date -->
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.preferredName"
            label="Preferred Name"
            :rules="[rules.alpha_char, rules.max100]"
            class="line-input custom-filled"
            dense
            hide-details="auto" />
        </div>
        <div class="form-group">
          <LessBadBirthDatePicker
            v-model="form.birthDate"
            :rules="[rules.max50]"
            class="line-input"
            dense
            hide-details="auto" />
        </div>
      </div>

      <!-- Address Fields -->
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.address1"
            label="Address 1"
            :rules="[rules.required, rules.alpha_char, rules.max100]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required />
        </div>
        <div class="form-group">
          <v-text-field
            v-model="form.address2"
            label="Address 2"
            :rules="[rules.alpha_char, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto" />
        </div>
      </div>

      <!-- City & State -->
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.city"
            label="City"
            :rules="[rules.required, rules.alpha_char, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required />
        </div>
        <div class="form-group">
          <v-select
            v-model="form.state"
            label="State"
            :rules="[rules.required]"
            :items="stateOptions"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required />
        </div>
      </div>

      <!-- Zip & Email -->
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.postalCode"
            label="Zip"
            :rules="[rules.required, rules.zip]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            required />
        </div>
        <div class="form-group">
          <v-text-field
            v-model="form.email"
            label="Email"
            :rules="[rules.email, rules.max50]"
            class="line-input custom-filled"
            dense
            hide-details="auto"
            disabled />
        </div>
      </div>

      <!-- Phone Numbers -->
      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.homePhone"
            v-mask="'(###) ###-####'"
            label="Home Phone Number"
            :rules="[rules.phone]"
            class="line-input custom-filled"
            type="tel"
            dense
            hide-details="auto"
            validate-on-blur />
        </div>
        <div class="form-group">
          <v-text-field
            v-model="form.cellPhone"
            v-mask="'(###) ###-####'"
            label="Cell Phone Number"
            :rules="[rules.phone]"
            class="line-input custom-filled"
            type="tel"
            dense
            hide-details="auto"
            validate-on-blur />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <v-text-field
            v-model="form.workPhone"
            v-mask="'(###) ###-####'"
            label="Work Phone Number"
            :rules="[rules.phone]"
            class="line-input custom-filled"
            type="tel"
            dense
            hide-details="auto"
            validate-on-blur />
        </div>
        <div class="form-group"></div>
      </div>

      <!-- Action Buttons -->
      <div class="form-actions">
        <v-btn
          class="btn-primary"
          @click="submitForm"
          :disabled="!isFormValid"
          :loading="isSubmitting">
          Save
        </v-btn>
        <v-btn
          class="btn-secondary"
          @click="$emit('cancel')">
          Cancel
        </v-btn>
        <v-btn
          class="btn-secondary"
          @click="cancelForm">
          Reset
        </v-btn>
      </div>
    </v-form>
    </div>
  </div>
</template>

<script>
import LessBadBirthDatePicker from '../../components/LessBadBirthDatePicker';
import DataService from '../../../_services/DataService';
import StateService from '../../../_services/StateService';
import ValidateService from '../../../_services/ValidateService';

export default {
  props: ['userInfo'],
  components: {
    LessBadBirthDatePicker,
  },
  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      form: {},
      rules: ValidateService.validators,
      stateOptions: [],
      alertFail: {
        text: 'Your profile could not be updated.',
        icon: 'mdi-alert-circle-outline',
        color: 'error',
      },
      alertSuccess: {
        text: 'Profile updated successfully',
        icon: 'mdi-alert-circle-outline',
        color: 'success',
      },
    };
  },
  methods: {
    getStates() {
      this.stateOptions = StateService.getStates()
        .map((state) => ({
          text: state.name,
          value: state.abbreviation,
        }));
    },
    setAlert(status, string) {
      let result = status == 'fail' ? this.alertFail : this.alertSuccess;
      if (string) {
        result.text = string;
      }
      return result;
    },
    async submitForm() {
      try {
        if (this.$refs.form.validate()) {
          this.isSubmitting = true;
          const response = await DataService.updatePatientInfo(this.form);

          if (response.status == 200) {
            this.$root.$emit('raise_alert', this.setAlert('success'));
          }
        }
      } catch (err) {
        this.$root.$emit('raise_alert', this.setAlert('fail'));
      } finally {
        this.isSubmitting = false;
      }
    },
    cancelForm() {
      this.form = {};
    },
  },
  created() {
    this.getStates();
  },
  async mounted() {
    if (this.userInfo) {
      this.form.firstName = this.userInfo.firstName;
      this.form.middleName = this.userInfo.middleName;
      this.form.lastName = this.userInfo.lastName;
      this.form.preferredName = this.userInfo.preferredName;
      this.form.birthDate = this.userInfo.birthDate;
      this.form.address1 = this.userInfo.address1;
      this.form.address2 = this.userInfo.address2;
      this.form.city = this.userInfo.city;
      this.form.state = this.userInfo.state;
      this.form.postalCode = this.userInfo.postalCode;
      this.form.email = this.userInfo.email;
      this.form.homePhone = this.userInfo.homePhone;
      this.form.cellPhone = this.userInfo.cellPhone;
      this.form.workPhone = this.userInfo.workPhone;
    } else {
      const patientResp = await DataService.getPatientInfo();
      this.form.firstName = patientResp.data.firstName;
      this.form.middleName = patientResp.data.middleName;
      this.form.lastName = patientResp.data.lastName;
      this.form.preferredName = patientResp.data.preferredName;
      this.form.birthDate = patientResp.data.birthDate;
      this.form.address1 = patientResp.data.address1;
      this.form.address2 = patientResp.data.address2;
      this.form.city = patientResp.data.city;
      this.form.state = patientResp.data.state;
      this.form.postalCode = patientResp.data.postalCode;
      this.form.email = patientResp.data.email;
      this.form.homePhone = patientResp.data.homePhone;
      this.form.cellPhone = patientResp.data.cellPhone;
      this.form.workPhone = patientResp.data.workPhone;
    }

    this.$refs.form.resetValidation();
  },
};
</script>
<style scoped>
</style>
